import { render } from "./Interventi.vue?vue&type=template&id=45aa8a5d&scoped=true&ts=true"
import script from "./Interventi.vue?vue&type=script&lang=ts"
export * from "./Interventi.vue?vue&type=script&lang=ts"

import "./Interventi.vue?vue&type=style&index=0&id=45aa8a5d&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45aa8a5d"]])

export default __exports__